// the list of styles that will use values outside of the shadow dom if they are set to inherit
const resetStyles = {
  'line-height': 'normal',
  'word-break': 'normal',
  visibility: 'visible',
  'text-align': 'initial',
  'font-size': 'initial',
  'font-style': 'normal',
  'font-variant': 'normal',
  'font-weight': 'normal',
  'text-transform': 'none',
  'text-indent': 'initial',
  'letter-spacing': 'normal',
}

/**
 * Scope global styles to the shadowDOM
 * @param {HTMLStyleElement} styleSheet the stylesheet to re-scope
 */
export function modifyStyleSheet(styleSheet) {
  const rules = [...styleSheet.cssRules]

  rules.forEach((rule) => {
    // re-scope the global styles to the shadow DOM
    if (rule.selectorText) {
      if (rule.selectorText === ':root') {
        rule.selectorText = rule.selectorText.replace(':root', ':host')
      }

      if (rule.selectorText === 'body') {
        rule.selectorText = rule.selectorText.replace('body', ':host')
      }
    }

    // This is done so that any `rem` based styles do not override any `html` level
    // styles that might be set by the host page.
    if (rule.style && rule.style.getPropertyValue('--text-base-size') !== '') {
      rule.style.setProperty('--text-base-size', '16px')
    }

    // This is done so that these are not overridden by the host page as these are affected by the host page's styles
    // and we want to ensure that the header/footer are not affected by the host page's styles
    if (rule.selectorText && rule.selectorText === ':host') {
      Object.entries(resetStyles).forEach(([prop, value]) => {
        rule.style.setProperty(prop, value)
      })
    }
  })
}

/** * Update the style sheets with new rules from mutations
 * @param {Object} params - The parameters for the function
 * @param {MutationRecord[]} params.mutations - The mutations to process
 * @returns {CSSStyleSheet | null} - The updated style sheet or null if no rules were added
 */
export function createStyleSheetFromMutations({ mutations }) {
  const rulesToAdd = []

  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          rulesToAdd.push(node.textContent)
        }
      })
    }
  })

  if (rulesToAdd.length === 0) {
    return null
  }

  const updatedStyleSheet = new CSSStyleSheet()
  updatedStyleSheet.replaceSync(rulesToAdd.join('\n'))
  modifyStyleSheet(updatedStyleSheet)

  return updatedStyleSheet
}
